ptTheme = {};
ptTheme.functions = {
    getParents: function (elem) {

        // Set up a parent array
        const parents = [];

        // Push each parent element to the array
        for (; elem && elem !== document; elem = elem.parentNode) {
            parents.push(elem);
        }

        // Return our parent array
        return parents;

    },
    siteNavigation() {
        //Navigations
        document.querySelectorAll('.pt-theme-mobile-button').forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.stopPropagation();
                e.preventDefault();
                let target = false;
                let button = false;

                if (e.target.classList.contains('pt-theme-mobile-button')) {
                    button = e.target;
                }

                ptTheme.functions.getParents(e.target).forEach(elem => {
                    if (elem.classList.contains('pt-theme-mobile-navigation')) {
                        target = elem;
                    }

                    if (!button && elem.classList.contains('pt-theme-mobile-button')) {
                        button = elem;
                    }
                });

                if (button && button.getAttribute('data-target')) {
                    target = document.querySelector(button.getAttribute('data-target'));
                }

                target.classList.toggle('opened');
                document.body.classList.toggle('pt-theme-backdrop');
            });
        });

        document.querySelectorAll('.pt-theme-close-button').forEach(function (el) {
            el.addEventListener('click', function (e) {
                ptTheme.functions.getParents(event.target).forEach(elem => {
                    if (elem.classList.contains('pt-theme-mobile-navigation') || elem.classList.contains('pt-theme-sidebar')) {
                        elem.classList.toggle('opened');
                    }
                });

                document.body.classList.toggle('pt-theme-backdrop');
            });
        });
    },
    sidebarNavigation() {
        function siteSidebar1() {
            document.querySelectorAll('.pt-theme-filters .pt-theme-filter .pt-theme-filters-heading').forEach(function (el) {
                el.addEventListener('click', function () {
                    el.parentElement.classList.toggle('show');
                });
            });

            document.querySelectorAll('.pt-theme-sidebar-button').forEach(function (el) {
                el.addEventListener('click', function () {
                    document.querySelector('.pt-theme-sidebar').classList.toggle('opened');
                    document.body.classList.toggle('pt-theme-backdrop');
                });
            });

            document.addEventListener("click", function (event) {
                let targetIsOutside = true;
                ptTheme.functions.getParents(event.target).forEach(elem => {
                    if (elem.classList.contains('pt-theme-sidebar') || elem.classList.contains('pt-theme-sidebar-button')) {
                        targetIsOutside = false;
                    }
                });

                if (targetIsOutside) {
                    if (document.querySelector('body').classList.contains('pt-theme-backdrop')) {
                        document.body.classList.remove('pt-theme-backdrop');
                    }
                    if (document.querySelector('.pt-theme-sidebar').classList.contains('opened')) {
                        document.querySelector('.pt-theme-sidebar').classList.remove('opened');
                    }
                }
            }, false)
        }

        function siteSidebar2() {
            document.querySelectorAll('.pt-theme-filters .pt-theme-filter .pt-theme-filters-heading').forEach(function (el) {
                el.addEventListener('click', function () {
                    el.parentElement.classList.toggle('show');
                });
            });

            document.querySelectorAll('.pt-theme-sidebar-button').forEach(function (el) {
                el.addEventListener('click', function () {
                    document.querySelector('.pt-theme-sidebar').classList.toggle('opened');
                    document.body.classList.toggle('pt-theme-backdrop');
                });
            });

            document.addEventListener("click", function (event) {
                let targetIsOutside = true;
                ptTheme.functions.getParents(event.target).forEach(elem => {
                    if (elem.classList.contains('pt-theme-sidebar') || elem.classList.contains('pt-theme-sidebar-button')) {
                        targetIsOutside = false;
                    }
                });

                if (targetIsOutside) {
                    if (document.querySelector('body').classList.contains('pt-theme-backdrop')) {
                        document.body.classList.remove('pt-theme-backdrop');
                    }
                    if (document.querySelector('.pt-theme-sidebar').classList.contains('opened')) {
                        document.querySelector('.pt-theme-sidebar').classList.remove('opened');
                    }
                }
            }, false)
        }

        function siteSidebar3() {
            document.querySelectorAll('.pt-theme-filters .pt-theme-filter .pt-theme-filters-heading').forEach(function (el) {
                el.addEventListener('click', function () {
                    el.parentElement.classList.toggle('show');
                });
            });

            document.querySelectorAll('.pt-theme-sidebar-button').forEach(function (el) {
                el.addEventListener('click', function () {
                    document.querySelector('.pt-theme-sidebar').classList.toggle('opened');
                    document.body.classList.toggle('pt-theme-backdrop');
                });
            });

            document.addEventListener("click", function (event) {
                let targetIsOutside = true;
                ptTheme.functions.getParents(event.target).forEach(elem => {
                    if (elem.classList.contains('pt-theme-sidebar') || elem.classList.contains('pt-theme-sidebar-button')) {
                        targetIsOutside = false;
                    }
                });

                if (targetIsOutside) {
                    if (document.querySelector('body').classList.contains('pt-theme-backdrop')) {
                        document.body.classList.remove('pt-theme-backdrop');
                    }
                    if (document.querySelector('.pt-theme-sidebar').classList.contains('opened')) {
                        document.querySelector('.pt-theme-sidebar').classList.remove('opened');
                    }
                }
            }, false)

        }

        function siteSidebar4() {
            document.querySelectorAll('.pt-theme-filters .pt-theme-filter .pt-theme-filters-heading').forEach(function (el) {
                el.addEventListener('click', function () {
                    el.parentElement.classList.toggle('show');
                });
            });

            document.querySelectorAll('.pt-theme-sidebar-button').forEach(function (el) {
                el.addEventListener('click', function () {
                    document.querySelector('.pt-theme-sidebar').classList.toggle('opened');
                    document.body.classList.toggle('pt-theme-backdrop');
                });
            });


            document.addEventListener("click", function (event) {
                let targetIsOutside = true;
                ptTheme.functions.getParents(event.target).forEach(elem => {
                    if (elem.classList.contains('pt-theme-sidebar') || elem.classList.contains('pt-theme-sidebar-button')) {
                        targetIsOutside = false;
                    }
                });

                if (targetIsOutside) {
                    if (document.querySelector('body').classList.contains('pt-theme-backdrop')) {
                        document.body.classList.remove('pt-theme-backdrop');
                    }
                    if (document.querySelector('.pt-theme-sidebar').classList.contains('opened')) {
                        document.querySelector('.pt-theme-sidebar').classList.remove('opened');
                    }
                }
            }, false)

        }

        function siteSidebar5() {
            document.querySelectorAll('.pt-theme-filters .pt-theme-filter .pt-theme-filters-heading').forEach(function (el) {
                el.addEventListener('click', function () {
                    el.parentElement.classList.toggle('show');
                });
            });

            document.querySelectorAll('.pt-theme-sidebar-button').forEach(function (el) {
                el.addEventListener('click', function () {
                    document.querySelector('.pt-theme-sidebar').classList.toggle('opened');
                });
            });

            document.addEventListener("click", function (event) {
                let targetIsOutside = true;
                ptTheme.functions.getParents(event.target).forEach(elem => {
                    if (elem.classList.contains('pt-theme-sidebar') || elem.classList.contains('pt-theme-sidebar-button')) {
                        targetIsOutside = false;
                    }
                });

                if (targetIsOutside) {
                    if (document.querySelector('.pt-theme-sidebar').classList.contains('opened')) {
                        document.querySelector('.pt-theme-sidebar').classList.remove('opened');
                    }
                }
            }, false)
        }

        if (document.querySelector('.pt-theme-aside-filters[data-style="1"]')) {
            siteSidebar1();
        }
        if (document.querySelector('.pt-theme-aside-filters[data-style="2"]')) {
            siteSidebar2();
        }
        if (document.querySelector('.pt-theme-aside-filters[data-style="3"]')) {
            siteSidebar3();
        }
        if (document.querySelector('.pt-theme-aside-filters[data-style="4"]')) {
            siteSidebar4();
        }
        if (document.querySelector('.pt-theme-aside-filters[data-style="5"]')) {
            siteSidebar5();
        }
    },
    initPlugins: function () {
        document.body.setAttribute('data-page-scrolled', 'false');

        window.onscroll = function () {
            if (window.scrollY > 10) {
                document.body.setAttribute('data-page-scrolled', 'true');
            } else {
                document.body.setAttribute('data-page-scrolled', 'false');
            }

            initAnimationsForVisibleElements();
        };

        initAnimationsForVisibleElements();

        setTimeout(function () {
            AOS.init();
        }, 100);

        setTimeout(function () {
            document.body.classList.add('plumtex-store-loaded');
        }, 150);

        $('[data-slick]').slick();

        $('[data-selectpicker]').selectpicker();

        const lightbox = GLightbox({
            touchNavigation: true,
            loop: true,
            autoplayVideos: true
        });

        ptTheme.functions.bsAccordionsWithTimerInit();

        const mixItUpContainers = document.querySelectorAll('[data-mixitup]');
        if (mixItUpContainers) {
            mixItUpContainers.forEach(function (container) {
                let mixitupSettings = {};
                if (container.getAttribute('data-mixitup') && container.getAttribute('data-mixitup') != '') {
                    mixitupSettings = container.getAttribute('data-mixitup');
                    mixitupSettings = JSON.parse(mixitupSettings);
                }

                const mixer = mixitup(container, mixitupSettings);
            });
        }

        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl)
        })


        $('.js-show-register-window').on('click', function () {
            $('.js-login-window').hide();
            $('.js-register-window').show();
            $('.js-forgotten-password-window').hide();
        });

        $('.js-show-login-window').on('click', function () {
            $('.js-login-window').show();
            $('.js-register-window').hide();
            $('.js-forgotten-password-window').hide();
        });

        $('.js-show-forgotten-password-window').on('click', function () {
            $('.js-login-window').hide();
            $('.js-register-window').hide();
            $('.js-forgotten-password-window').show();
        });
    },
    goToSlickSlide: function (sliderID, slide) {
        const sliderSelector = '[data-slider-id="' + sliderID + '"]';
        const slider = document.querySelector(sliderSelector);

        const currentElement = slider.querySelector(sliderSelector + ' .slider-navigation ul li.active');
        const currentElementIndex = Array.from(slider.querySelectorAll(sliderSelector + ' .slider-navigation ul li')).indexOf(currentElement);
        // const clickedElement = slider.querySelector(sliderSelector + ' .slider-navigation ul li:nth-of-type(' + parseInt(parseInt(slide) + 1) + ')');
        // const firstElement = slider.querySelector(sliderSelector + ' .slider-navigation ul li:nth-of-type(' + parseInt(parseInt(slide)) + ')');
        // const lastElement = slider.querySelector(sliderSelector + ' .slider-navigation ul li:nth-of-type(' + parseInt(parseInt(slide) + 2) + ')');

        if (currentElementIndex > slide) {
            $(sliderSelector + ' .slider-navigation').stop().animate({scrollLeft: "-=200"}, 500);
        } else if (currentElementIndex < slide) {
            $(sliderSelector + ' .slider-navigation').stop().animate({scrollLeft: "+=200"}, 500);
        }

        setTimeout(function () {
            slider.querySelectorAll('.item').forEach(function (item) {
                item.classList.remove('active');
            });
            slider.querySelectorAll('.item')[slide].classList.add('active');

            $(sliderSelector + ' ' + '[data-slick]').slick('slickGoTo', slide);
        }, 150)
    },
    isElementVisibleInViewport: function (el, partiallyVisible = false) {
        const {top, left, bottom, right} = el.getBoundingClientRect();
        const {innerHeight, innerWidth} = window;
        return partiallyVisible
            ? ((top > 0 && top < innerHeight) ||
                (bottom > 0 && bottom < innerHeight)) &&
            ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
            : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
    },
    dynamicLoadIframe: function (selector) {
        if (!document.querySelector(selector + ' iframe').src) {
            document.querySelector(selector + ' iframe').src = document.querySelector(selector + ' iframe').getAttribute('data-src');
        }
    },

    bsAccordionWithTimerStartFrom: function (accordion, slideIndex) {
        if (typeof accordion == 'string') {
            accordion = document.querySelector(accordion);
        }

        ptTheme.functions.bsAccordionWithTimerStart(accordion, slideIndex)

        //accordion.setAttribute('next-slide', slideIndex);
    },
    bsAccordionWithTimerStart: function (accordion, currentIndex = false) {
        const openSlide = (index, timerInterval, callback) => {
            const itemsCount = accordion.querySelectorAll('.accordion-item').length;

            const accordionItem = accordion.querySelectorAll('.accordion-item')[index];
            const accordionSubItem = accordion.querySelectorAll('.accordion-subitem')[index];

            const button = accordionItem.querySelector('.accordion-button');
            const content = accordionItem.querySelector('.accordion-collapse');

            for (let i = 0; i < itemsCount; i++) {
                const eachItem = accordion.querySelectorAll('.accordion-item')[i];
                const eachSubItem = accordion.querySelectorAll('.accordion-subitem')[i];

                const button = eachItem.querySelector('.accordion-button');
                const content = eachItem.querySelector('.accordion-collapse');

                eachSubItem.classList.remove('show');
                button.classList.add('collapsed');
                content.classList.remove('show');
            }

            accordion.setAttribute('current-slide', index);
            accordionSubItem.classList.add('show');
            content.classList.add('collapsing');
            button.classList.remove('collapsed');
            content.classList.add('show');
            content.classList.remove('collapsing');
            $(accordionItem).find(".animated-progress span").each(function () {
                $(this).css({'width': '0'});

                $(this).animate(
                    {width: $(this).attr("data-progress") + "%"},
                    timerInterval
                );
            });

            if (window._accordionTimer) {
                clearTimeout(window._accordionTimer);
            }
            window._accordionTimer = setTimeout(function () {
                accordionSubItem.classList.remove('show');
                content.classList.add('collapsing');
                button.classList.add('collapsed');
                content.classList.remove('show');
                content.classList.remove('collapsing');
                if (callback) {
                    callback();
                }
            }, timerInterval)
        }

        let timer = 0;
        let timerInterval = 10000;

        const itemsCount = accordion.querySelectorAll('.accordion-item').length;

        if (currentIndex != false) {
            timer = 0;
            clearTimeout(window._accordionTimer)
            delete window._accordionTimer;
        }

        if (currentIndex == false) {
            currentIndex = 0;
        }

        window._accordionTimerIndex = currentIndex;
        openSlide(window._accordionTimerIndex, timerInterval, function () {
            const itemsCount = accordion.querySelectorAll('.accordion-item').length;

            window._accordionTimerIndex++;

            if (window._accordionTimerIndex >= itemsCount) {
                window._accordionTimerIndex = 0;
                ptTheme.functions.bsAccordionWithTimerStart(accordion);
            } else {
                ptTheme.functions.bsAccordionWithTimerStart(accordion, window._accordionTimerIndex);
            }
        });
    },
    bsAccordionsWithTimerInit() {
        if (document.querySelector('.accordion-with-timer')) {
            document.querySelectorAll('.accordion-with-timer').forEach(accordion => {
                ptTheme.functions.bsAccordionWithTimerStart(accordion)
            })
        }
    }
}

$(document).ready(function () {
    ptTheme.functions.siteNavigation();
    ptTheme.functions.sidebarNavigation();
    ptTheme.functions.initPlugins();
});

//Close overlay menus
document.addEventListener("click", function (event) {
    let targetIsOutside = true;
    ptTheme.functions.getParents(event.target).forEach(elem => {
        if (elem.classList.contains('pt-theme-sidebar') || elem.classList.contains('pt-theme-sidebar-button') || elem.classList.contains('pt-theme-mobile-navigation')) {
            targetIsOutside = false;
        }
    });

    if (targetIsOutside) {
        if (document.querySelector('body').classList.contains('pt-theme-backdrop')) {
            document.body.classList.remove('pt-theme-backdrop');
        }
        if (document.querySelector('.pt-theme-sidebar') && document.querySelector('.pt-theme-sidebar').classList.contains('opened')) {
            document.querySelector('.pt-theme-sidebar').classList.remove('opened');
        }
        document.querySelectorAll('.pt-theme-mobile-navigation').forEach(el => {
            if (el.classList.contains('opened')) {
                el.classList.remove('opened');
            }
        })
    }
}, false)


function initAnimationsForVisibleElements() {
    setTimeout(function () {
        let timer = 0;
        if (document.querySelectorAll('[pt-text-animation]:not(.pt-view-port-revealed)')) {
            document.querySelectorAll('[pt-text-animation]:not(.pt-view-port-revealed)').forEach(element => {
                if (ptTheme.functions.isElementVisibleInViewport(element)) {
                    setTimeout(function () {
                        element.classList.add('pt-view-port-revealed');
                    }, timer)
                    timer = timer + 500;
                }
            })
        }
    }, 100)
}